function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
module.exports = PotTemplate = function PotTemplate(comp) {
  var wide = comp.ticker === 'CHIPS' || _typeof(comp.game_mod.game.stake) === 'object';
  return "\n\t\t<div class=\"pot\">\n\t  \t  <div class=\"potholder".concat(wide ? '' : ' squeeze', "\">\n\t\t\t<div class=\"line2\"></div>\n\t\t\t<div class=\"line3\"></div>\n\t \t  </div>\n\t\t</div>\n\t\t");
};